import { CbTemplateViewProps } from "../cb-template-view/cb-template-view.props";

import { CbTemplateControlProps } from "./cb-template-control.props";

export function createCbTemplateControlProps(
  cbTemplateViewProps: CbTemplateViewProps
): CbTemplateControlProps {
  return {
    form: cbTemplateViewProps.form,
    userPermissions: cbTemplateViewProps.userPermissions,
  };
}
